import { render } from "./ModalConfirmarAcao.vue?vue&type=template&id=5738c64e"
import script from "./ModalConfirmarAcao.vue?vue&type=script&lang=js"
export * from "./ModalConfirmarAcao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__